<template>
<div class="contactPage">
	<div class="contactImageBox" ref="headerImageRef">
		<img class="contactImage" src="@/assets/contactIMG.png" />
	</div>

    <div class="contactBoxLine">
        <div class="contactItem">
            <img class="contactImage" src="@/assets/contact0.png" />
            <div class="contactText">
                上海市徐汇区绿地中心A座1502C
            </div>
        </div>
        <div style="flex: 1; height: 1px;" />
        <div class="contactItem">
            <img class="contactImage" src="@/assets/contact1.png" />
            <div class="contactText">
                （021）6330 7977
            </div>
        </div>
        <div style="flex: 1; height: 1px;" />
        <div class="contactItem">
            <img class="contactImage" src="@/assets/contact2.png" />
            <div class="contactText">
                info@dopulses.com
            </div>
        </div>
    </div>

    <div style="height: 16rem; width: 1px;" />
    <div class="utilityBox">
        <iframe class="utilityItem"
            src="https://uri.amap.com/marker?position=121.458791,31.186356&name=绿地中心"
            width="100%"
            height="100%"
            frameborder="0">
        </iframe>
        <div style="width: 2rem; height: 1px;" />
        <div class="utilityItem" style="box-shadow: 0px 0.3rem 3.3rem 0px rgba(51, 51, 51, 0.05);">
            <input v-model="hp" class="hp" autocomplete="off" tabindex="-1" />

            <div style="height: 3.3rem; width: 1px;" />
            <input class="feedbackInput" v-model.trim="name" placeholder="请输入姓名" />
            <div style="flex: 1; width: 1px;" />
            <input class="feedbackInput" v-model.trim="contact" placeholder="请输入邮箱" type="email" />
            <div style="flex: 1; width: 1px;" />
            <textarea class="feedbackInput" v-model.trim="message" placeholder="留言内容" rows="5" maxlength="240"></textarea>
            <div style="flex: 2; width: 1px;" />

            <button class="feedbackButton" :disabled="loading" @click="submit">
                {{ loading ? "提交中..." : "提交" }}
                <img class="feedbackIcon" src="@/assets/arrow.png" v-if="!loading" />
            </button>
            <div v-if="ok">已发送给维护方 ✅</div>
            <div v-if="err" class="err">发送失败：{{ err }}</div>
            <div style="height: 3rem; width: 1px;" />
        </div>
    </div>

    <div style="height: 11.7rem; width: 1px;" />
</div>
</template>

<script>
export default {
	data() {
		return {
            name: "",
            contact: "",
            message: "",
            hp: "",
            loading: false,
            ok: false,
            err: ""
		}
	},
	methods: {
        isEmailValid(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(email);
        },

        async submit() {
            this.ok = false;
            this.err = "";

            if (this.hp) return;

            if (!this.contact || !this.message) {
                this.err = "请填写邮箱和留言";
                return;
            }

            if (!this.isEmailValid(this.contact)) {
                this.err = "请输入正确的邮箱地址";
                return;
            }

            this.ok = false; this.err = "";
            if (this.hp) return;
            if (!this.contact || !this.message) { this.err = "请填写联系方式和留言"; return; }

            const WEBHOOK_URL = "https://open.feishu.cn/open-apis/bot/v2/hook/40e81a77-a593-466f-9eab-08a636440845";
            const text =
                `【网站留言】\n姓名：${this.name}\n联系方式：${this.contact}\n留言：${this.message}\n时间：${new Date().toISOString()}`;

            this.loading = true;
            try {
                const res = await fetch(WEBHOOK_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ msg_type: "text", content: { text } })
                });
                const data = await res.json().catch(() => ({}));
                // 飞书 webhook 正常会返回 code/msg（不同版本字段可能略有差异）
                if (!res.ok || (data.code && data.code !== 0)) throw new Error(data.msg || "HTTP " + res.status);
                this.ok = true;
                this.name = ""; this.contact = ""; this.message = "";
            } catch (e) {
                this.err = e.message || String(e);
            } finally {
                this.loading = false;
            }
        },

		emitHeroHeight() {
			const height = this.$refs.headerImageRef ? this.$refs.headerImageRef.offsetHeight : 20;
			this.$emit("headerImageRefHeight", height);
		}
	},
	created() {
	},
	mounted() {
		this.emitHeroHeight();
		window.addEventListener("resize", this.emitHeroHeight);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.emitHeroHeight);
	},
	watch: {
	},
}
</script>

<style lang="scss" scoped>
.contactPage {
    display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
    
	.contactImageBox {
		width: 100%;
		height: 51.4rem;
		position: relative;
		background-color: #212121;

		.contactImage {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0px;
			left: 0px;
			object-fit: cover;
		}
	}

    .contactBoxLine {
        position: absolute;
        top: 42.1rem;
        box-sizing: border-box;
        width: 100rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .contactItem {
            width: 32.1rem;
            height: 17rem;
            background-color: #FFFFFF;
            border-radius: 0.8rem;
            box-shadow: 0px 0.3rem 3.3rem 0px rgba(51, 51, 51, 0.05);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .contactImage {
                width: 5rem;
                height: 5rem;
                margin-bottom: 1.7rem;
            }
            .contactText {
                font-size: 1.3rem;
                line-height: 2.1rem;
                color: #333333;
            }
        }
    }

    .utilityBox {
        box-sizing: border-box;
        width: 100rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .utilityItem {
            flex: 1;
            height: 39.2rem;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;

            .mapMaskBox {
                position: absolute;
                z-index: 300;
                width: 100%;
                height: 100%;
                border-radius: 0.8rem;
            }

            .feedbackInput {
                width: calc(100% - 5.4rem - 2.8rem);
                margin-left: 2.7rem;
                margin-right: 2.7rem;
                padding: 1.9rem 1.4rem;
                font-size: 1.2rem;
                line-height: 1.8rem;
                color: #333333;
                border: none;
                background-color: #FAFAFA;

                font-family: inherit;
                font-weight: 400;
                resize: none;
            }
            input:focus {
                outline: none;
                border: none;
            }
            textarea:focus {
                outline: none;
                border: none;
            }
            .feedbackButton {
                width: calc(10.8rem + 2.7rem);
                height: 4.5rem;
                background-color: #78DFA2;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                margin-left: 2.7rem;
                color: #FFFFFF;
                font-size: 1.5rem;

                .feedbackIcon {
                    display: inline-block;
                    width: 1.7rem;
                    height: 1.7rem;
                }
            }
            button {
                outline: none;
                border: none;
            }

            .ok { color: #1a7f37; margin-left: 2.7rem; }
            .err { color: #b42318; margin-left: 2.7rem; }
            .hp { position: absolute; left: -9999px; opacity: 0; height: 0; }
        }
    }
}
</style>